<div class="cargandoCent text-center" *ngIf="cargandoCat">
  <i class="fak fa-implementos fa-bounce"></i>
  <div
    class="fa-beat-fade"
    style="--fa-beat-fade-opacity: 0.67; --fa-beat-fade-scale: 1.075"
  >
    Cargando cat&aacute;logo...
  </div>
</div>
<div *ngIf="dispositivo === 'smartphone'">
  <div class="m-0 p-0">
    <div class="mobile-header" *ngIf="tags.length" class="py-0">
      <app-template-menu-catalogo
        [tags]="tags"
        [tipoDispositivo]="dispositivo"
        [origen]="this"
        nameOrigen="ver-catalogo-flip"
      ></app-template-menu-catalogo>
    </div>
    <div
      class="flip-book"
      #demoBookExample
      id="demoBookExample"
      [ngClass]="tags.length > 0 ? 'tags' : 'notags'"
    >
      <div
        class="page page-cover page-cover-top p-0"
        data-density="hard"
        *ngIf="tipoCatalogo == 'Automatico' && !Generico"
      >
        <div class="page-content" data-density="hard">
          <div class="containerP">
            <div class="text-white text-overlaym" *ngIf="nombreCliente">
              <p class="text-center">
                {{ nombreCliente | slice : 14 }}
              </p>
              <p class="text-center">Productos recomendados para ti!!</p>
            </div>
            <img
              class="img-fluid"
              src="{{ portada }}"
              onError="this.src='./assets/images/catalogo/place-150x150.png'"
              alt=""
            />
          </div>
        </div>
      </div>
      <div
        class="page page-cover page-cover-top p-0"
        data-density="hard"
        *ngIf="tipoCatalogo != 'Automatico' || Generico"
      >
        <div class="page-content" data-density="hard">
          <img
            class="img-fluid"
            src="{{ portada }}"
            onError="this.src='./assets/images/catalogo/place-150x150.png'"
            alt=""
          />
        </div>
      </div>
      <ng-container
        *ngFor="let pagina of paginasMobile; let i = index; let ultimo = last"
      >
        <div class="page p-0" *ngIf="pagina[0].type != 'portada'">
          <div class="page-content">
            <div>
              <div>
                <div
                  class="container-fluid p-2 justify-content-between"
                  style="background-color: #00967f"
                >
                  <div class="row justify-content-between">
                    <div class="col-9 py-0">
                      <div>
                        <img
                          style="margin-top: 5px; width: 75%; height: 75%"
                          class="img-fluid"
                          src="/assets/images/catalogo/header-footer/Header-movil_1.SVG"
                        />
                      </div>
                    </div>
                    <div class="col-3 py-0" *ngIf="!folio">
                      <div class="mobile-header__indicators">
                        <div class="indicator indicator--mobile">
                          <a
                            [routerLink]="['/', 'carro-compra']"
                            class="indicator__button"
                          >
                            <span class="indicator__area">
                              <app-icon name="cart-20" size="30"></app-icon>
                              <span class="indicator__value">{{
                                cart.quantity$ | async
                              }}</span>
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  style="
                    color: rgb(255, 255, 255);
                    background-color: #575756;
                    padding: 2px;
                    padding-left: 10px;
                  "
                >
                  <b>{{ pagina[0].titulo }}</b>
                </div>
              </div>

              <div>
                <div class="row px-1 m-0">
                  <div
                    class="col-6 py-0 col2p"
                    *ngIf="pagina[0] && pagina[0].products"
                  >
                    <app-template-mobile
                      [plana]="pagina[0]"
                      [tipo]="tipoCatalogo"
                      style="z-index: 999"
                      [showTaxes]="showTaxes"
                      [folio]="folio"
                    />
                  </div>
                  <div
                    class="col-6 py-0 col2p"
                    *ngIf="pagina[1] && pagina[1].products"
                  >
                    <app-template-mobile
                      [plana]="pagina[1]"
                      [tipo]="tipoCatalogo"
                      style="z-index: 999"
                      [showTaxes]="showTaxes"
                      [folio]="folio"
                    />
                  </div>
                  <div
                    class="col-6 py-0 col2p"
                    *ngIf="pagina[2] && pagina[2].products"
                  >
                    <app-template-mobile
                      [plana]="pagina[2]"
                      [tipo]="tipoCatalogo"
                      style="z-index: 999"
                      [showTaxes]="showTaxes"
                      [folio]="folio"
                    />
                  </div>
                  <div
                    class="col-6 py-0 col2p"
                    *ngIf="pagina[3] && pagina[3].products"
                  >
                    <app-template-mobile
                      [plana]="pagina[3]"
                      [tipo]="tipoCatalogo"
                      style="z-index: 999"
                      [showTaxes]="showTaxes"
                      [folio]="folio"
                    />
                  </div>
                  <div
                    class="col-6 py-0 col2p"
                    *ngIf="pagina[4] && pagina[4].products"
                  >
                    <app-template-mobile
                      [plana]="pagina[4]"
                      [tipo]="tipoCatalogo"
                      style="z-index: 999"
                      [showTaxes]="showTaxes"
                      [folio]="folio"
                    />
                  </div>
                  <div
                    class="col-6 py-0 col2p"
                    *ngIf="pagina[5] && pagina[5].products"
                  >
                    <app-template-mobile
                      [plana]="pagina[5]"
                      [tipo]="tipoCatalogo"
                      style="z-index: 999"
                      [showTaxes]="showTaxes"
                      [folio]="folio"
                    />
                  </div>
                  <div
                    class="col-6 py-0 col2p"
                    *ngIf="pagina[6] && pagina[6].products"
                  >
                    <app-template-mobile
                      [plana]="pagina[6]"
                      [tipo]="tipoCatalogo"
                      style="z-index: 999"
                      [showTaxes]="showTaxes"
                      [folio]="folio"
                    />
                  </div>
                  <div
                    class="col-6 py-0 col2p"
                    *ngIf="pagina[7] && pagina[7].products"
                  >
                    <app-template-mobile
                      [plana]="pagina[7]"
                      [tipo]="tipoCatalogo"
                      style="z-index: 999"
                      [showTaxes]="showTaxes"
                      [folio]="folio"
                    />
                  </div>
                </div>
              </div>

              <div
                class="container-fluid"
                style="background-color: #0070ba; padding: 12px"
              >
                <div class="justify-content-between">
                  <img
                    class="p-1"
                    style="width: 18%; height: 18%"
                    src="/assets/images/catalogo/header-footer/Icono_1.SVG"
                  />
                  <img
                    class="p-1"
                    style="width: 30%; height: 30%"
                    src="/assets/images/catalogo/header-footer/Icono_2.SVG"
                  />
                  <img
                    class="p-1"
                    style="width: 20%; height: 20%"
                    src="/assets/images/catalogo/header-footer/Icono_3.SVG"
                  />
                  <img
                    class="p-1"
                    style="width: 30%; height: 30%"
                    src="/assets/images/catalogo/header-footer/Icono_4.SVG"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <div class="page page-cover page-cover-bottom">
        <div class="page-content">
          <img
            class="img-fluid"
            src="{{ contraPortada }}"
            onError="this.src='./assets/images/catalogo/place-150x150.png'"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="mobile-footer" *ngIf="!cargandoCat">
      <div class="container">
        <div class="row m-0 pt-1">
          <div class="col-4 py-0 text-center">
            <button
              class="btn"
              style="padding-top: 1rem !important"
              (click)="prevPage()"
            >
              <i
                class="fas fa-chevron-left"
                style="font-size: 20px"
                (click)="prevPage()"
              ></i>
            </button>
          </div>
          <div
            class="col-4 py-0 text-center"
            style="
              padding-top: 0.5rem !important;
              font-size: 20px;
              font-weight: 700;
            "
          >
            <span>{{ pageCurrent }}</span> de
            <span class="page-total">{{ pageTotal }}</span>
          </div>
          <div class="col-4 py-0 text-center">
            <button
              class="btn"
              style="padding-top: 1rem !important"
              (click)="nextPage()"
            >
              <i class="fas fa-chevron-right" style="font-size: 20px"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="dispositivo === 'web'">
  <div class="row justify-content-center mt-4">
    <div class="md:col-10 py-0" *ngIf="tags.length > 0">
      <app-template-menu-catalogo
        [tags]="tags"
        [tipoDispositivo]="dispositivo"
        [origen]="this"
        nameOrigen="ver-catalogo-flip"
        [tipoCatalogo]="tipoCatalogo"
      ></app-template-menu-catalogo>
    </div>
  </div>
  <!-- Carro de compras -->
  <div class="icon-chat shadow-lg pointer" *ngIf="!cargandoCat && !folio">
    <div
      class="indicator--trigger--click"
      appDropdown="indicator--opened"
      #cartDropdown="appDropdown"
      *ngIf="cart.isDropCartActive$ | async"
    >
      <a
        [href]="root.url('/productos/caro-compra')"
        class="indicator__button flex-column mt-2"
        (click)="$event.preventDefault(); cartDropdown.toggle()"
      >
        <span class="indicator__area indicator__area-cart">
          <app-icon name="cart-20" size="40"></app-icon>
          <span
            *ngIf="((cart.quantity$ | async) || 0) > 0"
            class="indicator__value"
            >{{ cart.quantity$ | async }}</span
          >
        </span>
      </a>
      <div class="indicator__dropdown">
        <app-header-dropcart></app-header-dropcart>
      </div>
    </div>
  </div>
  <div class="row justify-content-center mt-2">
    <div class="md:col-1 sm:col-4 py-0 pl-1">
      <div
        *ngIf="!cargandoCat && tipoCatalogo != 'Automatico'"
        class="float-start align-middle"
        style="margin-top: 24rem"
      >
        <button
          class="btn btn-transparent float-center"
          style="padding: 0px !important"
          (click)="prevPage()"
        >
          <i class="fas fa-chevron-left" style="font-size: 40px"></i>
        </button>
      </div>
      <div
        *ngIf="!cargandoCat && tipoCatalogo == 'Automatico'"
        class="float-start align-middle"
        style="margin-top: 24rem"
      >
        <button class="btn btn-transparent float-center" (click)="prevPage()">
          <i
            class="fa-sharp fa-light fa-circle-chevron-left fa-xl"
            style="font-size: 40px"
          ></i>
        </button>
      </div>
    </div>

    <div class="md:col-10 sm:col-10 py-0">
      <div
        class="flip-book"
        #demoBookExample
        id="demoBookExample"
        style="margin: 0 auto"
      >
        <!-- Portada -->
        <div
          class="page page-cover page-cover-top"
          data-density="soft"
          *ngIf="tipoCatalogo == 'Automatico' && !Generico"
        >
          <div class="page-content" data-density="soft">
            <div class="containerP">
              <div class="text-white text-overlay" *ngIf="nombreCliente">
                <p class="text-center">
                  {{ nombreCliente | slice : 14 }}
                </p>
                <p class="text-center">Productos recomendados para ti!!</p>
              </div>
              <img
                class="img-fluid"
                style="height: 83%; width: 100%"
                src="{{ portada }}"
                onError="this.src='./assets/images/catalogo/place-150x150.png'"
                alt=""
              />
            </div>
          </div>
        </div>
        <div
          class="page page-cover page-cover-top"
          data-density="soft"
          *ngIf="tipoCatalogo != 'Automatico' || Generico"
        >
          <div class="page-content" data-density="soft">
            <img
              class="img-fluid"
              style="height: 100%"
              src="{{ portada }}"
              onError="this.src='./assets/images/catalogo/place-150x150.png'"
              alt=""
            />
          </div>
        </div>
        <!-- Page -->
        <ng-container *ngFor="let pagina of paginas; let i = index">
          <div class="page" *ngIf="pagina[0].type != 'portada'">
            <div class="page-content">
              <div *ngIf="i % 2 === 0; else otro">
                <div class="row m-0">
                  <div class="md:col-12 py-0">
                    <div class="headerLeft">
                      <img
                        style="height: 40px"
                        src="./assets/images/catalogo/header-footer/Header-movil_1.SVG"
                      />
                    </div>
                  </div>
                </div>
                <div
                  *ngIf="pagina.leftTitle && tipoCatalogo != 'Automatico'"
                  style="
                    color: black;
                    font-weight: 700;
                    font-size: 1rem;
                    text-align: left;
                    margin-top: 0.2rem;
                  "
                >
                  <span style="padding-left: 0.5rem">{{
                    pagina.leftTitle
                  }}</span>
                </div>
                <div class="tituloAutomatico" style="height: 27px !important">
                  <span
                    style="padding-left: 0.5rem"
                    *ngIf="pagina.leftTitle && tipoCatalogo === 'Automatico'"
                    >{{ pagina.leftTitle }}</span
                  >
                </div>

                <!-- LISTA DE MARCAS A -->
                <div
                  *ngIf="!pagina.leftTitle && tipoCatalogo != 'Automatico'"
                  class=""
                >
                  <div
                    *ngIf="pagina.marcas"
                    class="row m-0 justify-content-around flex lista-marcas"
                  >
                    <div class="col py-0">
                      <img
                        src="https://images.implementos.cl/marcas/small/{{
                          pagina.marcas[0] | uppercase
                        }}.png"
                        alt="{{ pagina.marcas[0] }}"
                        style="height: 35px"
                        onError="this.src='./assets/images/catalogo/place-150x150.png'"
                      />
                    </div>
                    <div class="col py-0">
                      <img
                        src="https://images.implementos.cl/marcas/small/{{
                          pagina.marcas[1] | uppercase
                        }}.png"
                        alt="{{ pagina.marcas[1] }}"
                        style="height: 35px"
                        onError="this.src='./assets/images/catalogo/place-150x150.png'"
                      />
                    </div>
                    <div class="col py-0">
                      <img
                        src="https://images.implementos.cl/marcas/small/{{
                          pagina.marcas[2] | uppercase
                        }}.png"
                        alt="{{ pagina.marcas[2] }}"
                        style="height: 35px"
                        onError="this.src='./assets/images/catalogo/place-150x150.png'"
                      />
                    </div>
                    <div class="col py-0">
                      <img
                        src="https://images.implementos.cl/marcas/small/{{
                          pagina.marcas[3] | uppercase
                        }}.png"
                        alt="{{ pagina.marcas[3] }}"
                        style="height: 35px"
                        onError="this.src='./assets/images/catalogo/place-150x150.png'"
                      />
                    </div>
                    <div class="col py-0">
                      <img
                        src="https://images.implementos.cl/marcas/small/{{
                          pagina.marcas[4] | uppercase
                        }}.png"
                        alt="{{ pagina.marcas[4] }}"
                        style="height: 35px"
                        onError="this.src='./assets/images/catalogo/place-150x150.png'"
                      />
                    </div>
                    <div class="col py-0">
                      <img
                        src="https://images.implementos.cl/marcas/small/{{
                          pagina.marcas[5] | uppercase
                        }}.png"
                        alt="{{ pagina.marcas[5] }}"
                        style="height: 35px"
                        onError="this.src='./assets/images/catalogo/place-150x150.png'"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <ng-template #otro>
                <div>
                  <div class="row m-0">
                    <div class="md:col-12 py-0">
                      <div class="headerRight">
                        <img
                          style="height: 30%"
                          src="./assets/images/catalogo/header-footer/Header-movil_2.SVG"
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    *ngIf="pagina.rightTitle && tipoCatalogo != 'Automatico'"
                    style="
                      color: black;
                      font-weight: 700;
                      font-size: 1rem;
                      text-align: left;
                      margin-top: 0.2rem;
                    "
                  >
                    <span style="padding-left: 0.5rem">{{
                      pagina.rightTitle
                    }}</span>
                  </div>
                  <div
                    class="tituloAutomatico"
                    style="height: 27px !important"
                  >
                    <span
                      style="padding-left: 0.5rem"
                      *ngIf="
                        pagina.rightTitle && tipoCatalogo === 'Automatico'
                      "
                      >{{ pagina.rightTitle }}</span
                    >
                  </div>

                  <!-- LISTA DE MARCAS B -->
                  <div
                    *ngIf="!pagina.rightTitle && tipoCatalogo != 'Automatico'"
                    class=""
                  >
                    <div
                      *ngIf="pagina.marcas"
                      class="row m-0 justify-content-around flex lista-marcas"
                    >
                      <div class="col py-0">
                        <img
                          src="https://images.implementos.cl/marcas/small/{{
                            pagina.marcas[0] | uppercase
                          }}.png"
                          alt="{{ pagina.marcas[0] }}"
                          style="height: 35px"
                          onError="this.src='./assets/images/catalogo/place-150x150.png'"
                        />
                      </div>
                      <div class="col py-0">
                        <img
                          src="https://images.implementos.cl/marcas/small/{{
                            pagina.marcas[1] | uppercase
                          }}.png"
                          alt="{{ pagina.marcas[1] }}"
                          style="height: 35px"
                          onError="this.src='./assets/images/catalogo/place-150x150.png'"
                        />
                      </div>
                      <div class="col py-0">
                        <img
                          src="https://images.implementos.cl/marcas/small/{{
                            pagina.marcas[2] | uppercase
                          }}.png"
                          alt="{{ pagina.marcas[2] }}"
                          style="height: 35px"
                          onError="this.src='./assets/images/catalogo/place-150x150.png'"
                        />
                      </div>
                      <div class="col py-0">
                        <img
                          src="https://images.implementos.cl/marcas/small/{{
                            pagina.marcas[3] | uppercase
                          }}.png"
                          alt="{{ pagina.marcas[3] }}"
                          style="height: 35px"
                          onError="this.src='./assets/images/catalogo/place-150x150.png'"
                        />
                      </div>
                      <div class="col py-0">
                        <img
                          src="https://images.implementos.cl/marcas/small/{{
                            pagina.marcas[4] | uppercase
                          }}.png"
                          alt="{{ pagina.marcas[4] }}"
                          style="height: 35px"
                          onError="this.src='./assets/images/catalogo/place-150x150.png'"
                        />
                      </div>
                      <div class="col py-0">
                        <img
                          src="https://images.implementos.cl/marcas/small/{{
                            pagina.marcas[5] | uppercase
                          }}.png"
                          alt="{{ pagina.marcas[5] }}"
                          style="height: 35px"
                          onError="this.src='./assets/images/catalogo/place-150x150.png'"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
              <div class="row m-0">
                <ng-container *ngFor="let plana of pagina">
                  <!-- Producto S - size:1  -->
                  <div *ngIf="plana.size == 1" class="p-0">
                    <app-template-s
                      [plana]="plana"
                      [tipo]="tipoCatalogo"
                      [showTaxes]="showTaxes"
                      [folio]="folio"
                    />
                  </div>
                  <!-- Producto M - size:2  -->
                  <div *ngIf="plana.size == 2" class="p-0">
                    <app-template-m [plana]="plana" [tipo]="tipoCatalogo">
                    </app-template-m>
                  </div>
                  <!-- Producto L - size:3  -->
                  <div *ngIf="plana.size == 3" class="p-0">
                    <app-template-l [plana]="plana" [tipo]="tipoCatalogo">
                    </app-template-l>
                  </div>
                  <!-- Producto XL - size:4  -->
                  <div *ngIf="plana.size == 4" class="p-0">
                    <app-template-xl [plana]="plana" [tipo]="tipoCatalogo">
                    </app-template-xl>
                  </div>
                </ng-container>
              </div>

              <div *ngIf="i % 2 === 0; else otroFooter">
                <div class="row m-0">
                  <div class="md:col-12 py-0">
                    <div *ngIf="folio">
                      <img
                        class="img-fluid"
                        src="./assets/images/catalogo/header-footer/footer1.jpg"
                      />
                    </div>
                    <div class="text-start footerLeft" *ngIf="!folio">
                      <img
                        class="p-1"
                        style="height: 90%"
                        src="./assets/images/catalogo/header-footer/Icono_1.SVG"
                      />
                      <img
                        class="p-1"
                        style="height: 90%"
                        src="./assets/images/catalogo/header-footer/Icono_2.SVG"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <ng-template #otroFooter>
                <div class="row m-0">
                  <div class="md:col-12 py-0">
                    <div class="text-end" *ngIf="folio">
                      <img
                        class="img-fluid"
                        src="./assets/images/catalogo/header-footer/footer1.jpg"
                      />
                    </div>
                    <div class="footerRight text-end" *ngIf="!folio">
                      <img
                        class="p-1"
                        style="height: 90%"
                        src="./assets/images/catalogo/header-footer/Icono_3.SVG"
                      />
                      <img
                        class="p-1"
                        style="height: 90%"
                        src="./assets/images/catalogo/header-footer/Icono_4.SVG"
                      />
                    </div>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </ng-container>
        <!-- ContraPortada -->
        <div class="page page-cover page-cover-bottom">
          <div class="page-content">
            <img
              class="img-fluid"
              style="height: 100%"
              src="{{ contraPortada }}"
              onError="this.src='./assets/images/catalogo/place-150x150.png'"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>

    <div class="md:col-1 sm:col-1 py-0 pl-1">
      <div
        *ngIf="!cargandoCat && tipoCatalogo != 'Automatico'"
        class="float-end align-middle"
        style="margin-top: 24rem"
      >
        <button
          class="btn btn-transparent float-end"
          style="padding: 0px !important"
          (click)="nextPage()"
        >
          <i class="fas fa-chevron-right" style="font-size: 40px"></i>
        </button>
      </div>
      <div
        *ngIf="!cargandoCat && tipoCatalogo == 'Automatico'"
        class="float-end align-middle"
        style="margin-top: 24rem"
      >
        <button
          class="btn btn-transparent float-end"
          style="padding-right: 8rem"
          (click)="nextPage()"
        >
          <i
            class="fa-sharp fa-light fa-circle-chevron-right fa-2xl"
            style="font-size: 40px"
          ></i>
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="!cargandoCat" class="row">
    <div class="col-12 text-center mt-2 h6 py-0">
      <span>{{ pageCurrent }}</span> de
      <span class="page-total">{{ pageTotal }}</span>
    </div>
  </div>
</div>
<div *ngIf="dispositivo === 'tablet'" class="tablet">
  <div class="row justify-content-center m-0">
    <div class="flip-book" #demoBookExample id="demoBookExample">
      <!-- Portada -->
      <div
        class="page page-cover page-cover-top"
        data-density="soft"
        *ngIf="tipoCatalogo == 'Automatico' && !Generico"
      >
        <div class="page-content" data-density="soft">
          <div class="containerP">
            <div class="text-white text-overlay" *ngIf="nombreCliente">
              <p class="text-center">
                {{ nombreCliente | slice : 14 }}
              </p>
              <p class="text-center">Productos recomendados para ti!!</p>
            </div>
            <img
              class="img-fluid"
              style="height: 83%; width: 100%"
              src="{{ portada }}"
              onError="this.src='./assets/images/catalogo/place-150x150.png'"
              alt=""
            />
          </div>
        </div>
      </div>
      <div
        class="page page-cover page-cover-top"
        data-density="soft"
        *ngIf="tipoCatalogo != 'Automatico' || Generico"
      >
        <div class="page-content" data-density="soft">
          <img
            class="img-fluid"
            style="height: 100%"
            src="{{ portada }}"
            onError="this.src='./assets/images/catalogo/place-150x150.png'"
            alt=""
          />
        </div>
      </div>
      <!-- Page -->
      <ng-container *ngFor="let pagina of paginas; let i = index">
        <div class="page" *ngIf="pagina[0].type != 'portada'">
          <div class="page-content">
            <div>
              <div
                class="container-fluid p-2 justify-content-between"
                style="background-color: #00967f"
              >
                <div class="row m-0 justify-content-between">
                  <div class="col-9 py-0">
                    <div>
                      <img
                        style="margin-top: 5px; width: 45%; height: 45%"
                        src="/assets/images/catalogo/header-footer/Header-movil_1.SVG"
                      />
                    </div>
                  </div>
                  <div class="col-3 py-0" *ngIf="!folio">
                    <div class="mobile-header__indicators">
                      <div class="indicator indicator--mobile">
                        <a
                          [routerLink]="['/', 'carro-compra']"
                          class="indicator__button"
                        >
                          <span class="indicator__area">
                            <app-icon name="cart-20" size="30"></app-icon>
                            <span class="indicator__value">{{
                              cart.quantity$ | async
                            }}</span>
                          </span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="i % 2 === 0; else otro">
                <div
                  *ngIf="pagina.leftTitle && tipoCatalogo != 'Automatico'"
                  style="
                    color: black;
                    font-weight: 700;
                    font-size: 1rem;
                    text-align: left;
                    margin-top: 0.2rem;
                  "
                >
                  <span style="padding-left: 0.5rem">{{
                    pagina.leftTitle
                  }}</span>
                </div>
                <div
                  *ngIf="pagina.leftTitle && tipoCatalogo === 'Automatico'"
                  class="tituloAutomatico"
                >
                  <span style="padding-left: 0.5rem">{{
                    pagina.leftTitle
                  }}</span>
                </div>

                <!-- LISTA DE MARCAS A -->
                <div
                  *ngIf="!pagina.leftTitle && tipoCatalogo != 'Automatico'"
                  class="container"
                >
                  <div
                    *ngIf="pagina.marcas"
                    class="row m-0 justify-content-around flex lista-marcas"
                  >
                    <div class="col py-0">
                      <img
                        src="https://images.implementos.cl/marcas/small/{{
                          pagina.marcas[0] | uppercase
                        }}.png"
                        alt="{{ pagina.marcas[0] }}"
                        style="height: 35px"
                        onError="this.src='./assets/images/catalogo/place-150x150.png'"
                      />
                    </div>
                    <div class="col py-0">
                      <img
                        src="https://images.implementos.cl/marcas/small/{{
                          pagina.marcas[1] | uppercase
                        }}.png"
                        alt="{{ pagina.marcas[1] }}"
                        style="height: 35px"
                        onError="this.src='./assets/images/catalogo/place-150x150.png'"
                      />
                    </div>
                    <div class="col py-0">
                      <img
                        src="https://images.implementos.cl/marcas/small/{{
                          pagina.marcas[2] | uppercase
                        }}.png"
                        alt="{{ pagina.marcas[2] }}"
                        style="height: 35px"
                        onError="this.src='./assets/images/catalogo/place-150x150.png'"
                      />
                    </div>
                    <div class="col py-0">
                      <img
                        src="https://images.implementos.cl/marcas/small/{{
                          pagina.marcas[3] | uppercase
                        }}.png"
                        alt="{{ pagina.marcas[3] }}"
                        style="height: 35px"
                        onError="this.src='./assets/images/catalogo/place-150x150.png'"
                      />
                    </div>
                    <div class="col py-0">
                      <img
                        src="https://images.implementos.cl/marcas/small/{{
                          pagina.marcas[4] | uppercase
                        }}.png"
                        alt="{{ pagina.marcas[4] }}"
                        style="height: 35px"
                        onError="this.src='./assets/images/catalogo/place-150x150.png'"
                      />
                    </div>
                    <div class="col py-0">
                      <img
                        src="https://images.implementos.cl/marcas/small/{{
                          pagina.marcas[5] | uppercase
                        }}.png"
                        alt="{{ pagina.marcas[5] }}"
                        style="height: 35px"
                        onError="this.src='./assets/images/catalogo/place-150x150.png'"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <ng-template #otro>
                <div>
                  <div
                    *ngIf="pagina.rightTitle && tipoCatalogo != 'Automatico'"
                    style="
                      color: black;
                      font-weight: 700;
                      font-size: 1rem;
                      text-align: left;
                      margin-top: 0.2rem;
                    "
                  >
                    <span style="padding-left: 0.5rem">{{
                      pagina.rightTitle
                    }}</span>
                  </div>
                  <div
                    *ngIf="pagina.rightTitle && tipoCatalogo === 'Automatico'"
                    class="tituloAutomatico"
                  >
                    <span style="padding-left: 0.5rem">{{
                      pagina.rightTitle
                    }}</span>
                  </div>

                  <!-- LISTA DE MARCAS B -->
                  <div
                    *ngIf="!pagina.rightTitle && tipoCatalogo != 'Automatico'"
                    class="container"
                  >
                    <div
                      *ngIf="pagina.marcas"
                      class="row justify-content-around flex lista-marcas"
                    >
                      <div class="col py-0">
                        <img
                          src="https://images.implementos.cl/marcas/small/{{
                            pagina.marcas[0] | uppercase
                          }}.png"
                          alt="{{ pagina.marcas[0] }}"
                          style="height: 35px"
                          onError="this.src='./assets/images/catalogo/place-150x150.png'"
                        />
                      </div>
                      <div class="col py-0">
                        <img
                          src="https://images.implementos.cl/marcas/small/{{
                            pagina.marcas[1] | uppercase
                          }}.png"
                          alt="{{ pagina.marcas[1] }}"
                          style="height: 35px"
                          onError="this.src='./assets/images/catalogo/place-150x150.png'"
                        />
                      </div>
                      <div class="col py-0">
                        <img
                          src="https://images.implementos.cl/marcas/small/{{
                            pagina.marcas[2] | uppercase
                          }}.png"
                          alt="{{ pagina.marcas[2] }}"
                          style="height: 35px"
                          onError="this.src='./assets/images/catalogo/place-150x150.png'"
                        />
                      </div>
                      <div class="col py-0">
                        <img
                          src="https://images.implementos.cl/marcas/small/{{
                            pagina.marcas[3] | uppercase
                          }}.png"
                          alt="{{ pagina.marcas[3] }}"
                          style="height: 35px"
                          onError="this.src='./assets/images/catalogo/place-150x150.png'"
                        />
                      </div>
                      <div class="col py-0">
                        <img
                          src="https://images.implementos.cl/marcas/small/{{
                            pagina.marcas[4] | uppercase
                          }}.png"
                          alt="{{ pagina.marcas[4] }}"
                          style="height: 35px"
                          onError="this.src='./assets/images/catalogo/place-150x150.png'"
                        />
                      </div>
                      <div class="col py-0">
                        <img
                          src="https://images.implementos.cl/marcas/small/{{
                            pagina.marcas[5] | uppercase
                          }}.png"
                          alt="{{ pagina.marcas[5] }}"
                          style="height: 35px"
                          onError="this.src='./assets/images/catalogo/place-150x150.png'"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </div>

            <ng-container *ngFor="let plana of pagina">
              <!-- Producto S - size:1  -->
              <div *ngIf="plana.size == 1" class="p-0">
                <app-template-s
                  [plana]="plana"
                  [tipo]="tipoCatalogo"
                  [showTaxes]="showTaxes"
                  [folio]="folio"
                />
              </div>
              <!-- Producto M - size:2  -->
              <div *ngIf="plana.size == 2" class="p-0">
                <app-template-m [plana]="plana" [tipo]="tipoCatalogo">
                </app-template-m>
              </div>
              <!-- Producto L - size:3  -->
              <div *ngIf="plana.size == 3" class="p-0">
                <app-template-l [plana]="plana" [tipo]="tipoCatalogo">
                </app-template-l>
              </div>
              <!-- Producto XL - size:4  -->
              <div *ngIf="plana.size == 4" class="p-0">
                <app-template-xl [plana]="plana" [tipo]="tipoCatalogo">
                </app-template-xl>
              </div>
            </ng-container>

            <div
              class="container-fluid"
              style="background-color: #0070ba; padding: 12px"
            >
              <div class="justify-content-between">
                <img
                  class="p-1"
                  style="width: 16%; height: 16%"
                  src="/assets/images/catalogo/header-footer/Icono_1.SVG"
                />
                <img
                  class="p-1"
                  style="width: 28%; height: 28%"
                  src="/assets/images/catalogo/header-footer/Icono_2.SVG"
                />
                <img
                  class="p-1"
                  style="width: 18%; height: 18%"
                  src="/assets/images/catalogo/header-footer/Icono_3.SVG"
                />
                <img
                  class="p-1"
                  style="width: 28%; height: 28%"
                  src="/assets/images/catalogo/header-footer/Icono_4.SVG"
                />
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <!-- ContraPortada -->
      <div class="page page-cover page-cover-bottom">
        <div class="page-content">
          <img
            class="img-fluid"
            style="height: 100%"
            src="{{ contraPortada }}"
            onError="this.src='./assets/images/catalogo/place-150x150.png'"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
  <div
    class="col-12 py-0"
    class="mobile-header"
    *ngIf="tags.length > 0"
    style="font-size: 16px"
  >
    <app-template-menu-catalogo
      [tags]="tags"
      [tipoDispositivo]="dispositivo"
      [origen]="this"
      nameOrigen="ver-catalogo-flip"
    ></app-template-menu-catalogo>
  </div>
  <div class="mobile-footer" *ngIf="!cargandoCat">
    <div class="row m-0">
      <div class="col-4 py-0 text-center">
        <button
          class="btn"
          style="padding-top: 1rem !important"
          (click)="prevPage()"
        >
          <i class="fas fa-chevron-left" style="font-size: 20px"></i>
        </button>
      </div>
      <div
        class="col-4 py-0 text-center"
        style="
          padding-top: 0.5rem !important;
          font-size: 20px;
          font-weight: 700;
        "
      >
        <span>{{ pageCurrent }}</span> de
        <span class="page-total">{{ pageTotal }}</span>
      </div>
      <div class="col-4 py-0 text-center">
        <button
          class="btn"
          style="padding-top: 1rem !important"
          (click)="nextPage()"
        >
          <i class="fas fa-chevron-right" style="font-size: 20px"></i>
        </button>
      </div>
    </div>
  </div>
</div>
